export const prettifyDateTime = (dateStr: Date): string => {
  const date = new Date(dateStr);

  const optionsForDate = {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
  } as const;
  const formattedDate = new Intl.DateTimeFormat('en-US', optionsForDate).format(
    date,
  );

  const optionsForTime = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  } as const;
  const formattedTime = new Intl.DateTimeFormat('en-US', optionsForTime).format(
    date,
  );

  return `${formattedDate} – ${formattedTime}`;
};
